import type { TFunction } from "i18next"
import { z } from "zod"

import { SubscriptionStatusEnum } from "@/enums/subscriptions"

export const filterSubscriptionSchema = (t: TFunction) =>
  z.object({
    from: z.date({
      required_error: t("validation.startDateRequired"),
    }),
    to: z.date({
      required_error: t("validation.endDateRequired"),
    }),
    customerDocument: z.string().optional(),
    code: z.string().optional(),
    status: z
      .nativeEnum(SubscriptionStatusEnum)
      .or(z.string().default("ALL"))
      .optional(),
    paymentMethod: z.string().optional(),
    ownId: z.string().optional(),
    /** Aplica o período mesmo na busca por identificador exato. */
    includePeriodWithIdentifier: z.boolean(),
  })
export type FilterSubscriptionSchemaProps = z.infer<
  ReturnType<typeof filterSubscriptionSchema>
>
